import React from 'react';

import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  Actions,
  Action,
  CloseIcon,
} from '@gogame/components';

import PartnerField from './PartnerField';

export const PartnerCard = ({
  path,
  externalDepends = [],
  onRemove,
  id,
  name,
  autoSync,
  fields,
  checkboxes,
  description,
  credentials,
}) => {
  return (
    <Card elevation={6}>
      <CardHeader
        title={<PartnerField path={path} depends={externalDepends} />}
        disableTypography={true}
        action={
          <Actions>
            <Action component={() => autoSync} />
            <Action icon={<CloseIcon />} label={'Remove'} onClick={onRemove} />
          </Actions>
        }
      />
      <CardContent style={{ paddingBottom: 4 }}>
        <Grid container spacing={3}>
          {id && (
            <Grid item xs={12}>
              {id}
            </Grid>
          )}
          {name && (
            <Grid item xs={12}>
              {name}
            </Grid>
          )}
          {credentials && (
            <React.Fragment>
              <Grid item xs={6}>
                {credentials}
              </Grid>
              <Grid item xs={6}></Grid>
            </React.Fragment>
          )}
          {fields?.map((field, i) => (
            <Grid item xs={12 / fields.length} key={`filed_${i}`}>
              {field}
            </Grid>
          ))}
          {description && (
            <Grid item xs={12}>
              {description}
            </Grid>
          )}
          {checkboxes?.map((checkbox, i) => (
            <Grid item xs={12 / fields.length} key={`checkbox_${i}`}>
              {checkbox}
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default PartnerCard;
